import { useCallback } from 'react';

import { useFillColor } from '~extension/icon-library/context/FillColor';
import { ColorPickerComp } from './ColorPickerComp';
import { PickerItem } from './PickerItem';

type FillColorPickerProps = {
  disabled?: boolean;
};

export const FillColorPicker = ({ disabled }: FillColorPickerProps) => {
  const { availableFillColors, selectedFillColor, setFillColor, resetFillColor } = useFillColor();

  const handleColorOptionClick = useCallback(
    (color: string) => () => {
      if (!disabled) {
        setFillColor(color);
      }
    },
    [disabled, setFillColor],
  );

  const handleColorpOptionDefaultClick = useCallback(() => {
    if (!disabled) {
      resetFillColor();
    }
  }, [disabled, resetFillColor]);

  if (availableFillColors?.length) {
    return (
      <ColorPickerComp>
        {/*this is the transparent color*/}
        <PickerItem selected={!selectedFillColor} onClick={handleColorpOptionDefaultClick} rounded />
        {availableFillColors.map(color => {
          return (
            <PickerItem
              key={color}
              color={color}
              selected={color === selectedFillColor}
              onClick={handleColorOptionClick(color)}
              rounded
            />
          );
        })}
      </ColorPickerComp>
    );
  }
  return null;
};
